<template>
  <b-card class="eva-agent-card">
    <div v-if="!messages.length && !sessionLoading" class="enviame-logo-container mt-2">
      <img
        src="@/assets/images/logo/enviame_logo.svg"
        alt="logo"
        class="ml-1"
        style="width: 40px; vertical-align: middle;"
      />
    </div>
    <!-- Skeleton -->
    <EvaAgentSkeleton v-if="sessionLoading" />

    <div class="col-lg-8 col-md-10 col-sm-12 mx-auto" v-if="!sessionLoading">
      <!-- Título y descripción -->
      <h1 v-if="!messages.length" class="text-h4 font-weight-bold text-center mt-4">¡Pregúntale a EVA!</h1>
      <p v-if="!messages.length" class="mt-1 mb-3 w-80 mx-auto text-center">
        Obtén respuestas acerca de los servicios y tarifas de los couriers, gracias al motor de IA (Inteligencia artificial).
      </p>

      <!-- Historial de mensajes -->
      <div v-if="messages.length" ref="chatBox" id="chatBox" class="history-messages">
        <div v-for="(msg, index) in messages" :key="index" class="mb-2">
          <div :class="msg.role === 'user' ? 'text-right' : 'text-left'" id="container-message">

            <!-- Mensaje usuario -->
            <span v-if="msg.role === 'user'" class="question-eva-agent">
              <div class="user-initial">{{ firstInitial }}</div>
              <span class="align-middle align-content-center" v-html="msg.text"></span>
              <b-button variant="link" class="p-0 pl-1" @click="copyMessage(msg.text)"><feather-icon icon="CopyIcon" class="align-middle align-content-center"/></b-button>
            </span>

            <!-- Bot escribiendo / respuesta -->
            <div v-if="msg.role === 'bot'" class="p-1 answer-eva-agent">
              <span class="bot-initial">
                <img src="@/assets/images/logo/enviame_logo_white.svg" alt="Envíame" style="width: 18px; height: 18px; vertical-align: middle;" />
              </span>
              <LoadingDots v-if="msg.loading" text="Generando respuesta…" />
              <span v-else-if="msg.typing" v-html="formatMessage(msg.displayedText)"></span>
              <span v-else v-html="formatMessage(msg.text)"></span>
            </div>

            <div v-if="showSpace && index === messages.length - 1" class="space-message"></div>

          </div>
        </div>
        <!-- Preguntas predefinidas (botones) -->
        <PredefinedQuestions
          :questions="predefinedQuestions"
          @select="askPredefined"
          class="col-lg-11 col-md-11 col-sm-12 mx-auto mt-4"
          v-if="messages.length && activeQuestion"
        />
      </div>
    </div>

    <!-- Recuadro de consulta (input)-->
    <eva-chat-bar
      v-if="!sessionLoading"
      v-model="question"
      :country="form.country"
      :country-options="countryOptions"
      :loading="loading"
      @send="sendQuestion"
      @update:country="onCountryChange"
      @activateQuestions="activateQuestions"
      :activeQuestion="activeQuestion"
      :messages="messages"
      :class="[messages.length ? '' : 'eva-chat-bar', 'col-lg-8 col-md-10 col-sm-12 mx-auto']"
      :mySession="mySession"
    />

    <!-- Preguntas predefinidas (botones) -->
    <PredefinedQuestions
      :questions="predefinedQuestions"
      @select="askPredefined"
      class="col-lg-11 col-md-11 col-sm-12 mx-auto mt-4"
      v-if="!messages.length && !sessionLoading"
    />
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex'
import marked from 'marked'
import EvaChatBar from './components/EvaChatBar.vue'
import EvaAgentSkeleton from './components/EvaAgentSkeleton.vue'
import LoadingDots from './components/LoadingComponent.vue'
import PredefinedQuestions from './components/PredefinedQuestions.vue'

export default {
  name: 'EvaAgent',
  components: { EvaChatBar, EvaAgentSkeleton, LoadingDots, PredefinedQuestions },
  data() {
    return {
      question: '',
      loading: false,
      messages: [
        // { text: '¿Cuál es el tiempo de entrega promedio?', role: 'user', loading: false }
      ],
      sessionLoading: true,
      predefinedQuestions: [
        '¿Qué courier entrega los días sábado o fines de semana?',
        '¿Qué courier acepta carga peligrosa, perecibles u otras condiciones especiales?',
        '¿Qué couriers ofrecen seguro incluido? ¿De qué valor?',
        '¿Qué courier permite despachos sin mínimo?',
        '¿Qué opción me sirve si tengo un envío grande puntual?'
      ],
      fields: [],
      form: {},
      activeQuestion: false,
      showSpace: false,
      previousScrollTop: 0,
      isProgrammaticScroll: false
    }
  },
  computed: {
    ...mapGetters({
      allCountries: 'getCountriesCoverage',
      mySession: 'getSession'
    }),

    countryOptions () {
      return this.allCountries?.rows || []
    },
    firstInitial() {
      return this.mySession?.first_name?.charAt(0)?.toUpperCase() || ''
    }
  },
  watch: {
    mySession () {
      if (this.mySession?.id && this.sessionLoading) {
        this.sessionLoading = false
        this.setInitialdata()
      }
    },
    // Cuando lleguen las opciones de país desactivamos el skeleton del campo
    allCountries () {
      if (this.allCountries?.rows && this.fields.length) {
        this.setOptionsCountry()
      }
    }
  },
  mounted() {
    this.$store.dispatch('fetchService', { name: 'getCountriesCoverage' })
    if (this.mySession?.id && this.sessionLoading) {
      this.sessionLoading = false
      this.setInitialdata()
    }

    this.$nextTick(() => {
      const chatBox = this.$refs.chatBox
      if (chatBox) {
        this.previousScrollTop = chatBox.scrollTop
        chatBox.addEventListener('scroll', this.onChatBoxScroll)
      }
    })

    // // Simula la respuesta hardcodeada con efecto typewriter
    // setTimeout(() => {
    //   const botPlaceholder = this.createBotPlaceholder()
    //   this.updateBotPlaceholder(botPlaceholder, 'Aquí tienes 5 couriers:\n \n *   **CorreosChile**\n \n *   **Bluexpress**\n \n *   **DHL**\n \n *   **Chilexpress**\n \n *   **Interno**\n \n *   **CorreosChile**\n \n *   **Bluexpress**\n \n *   **DHL**\n \n *   **Chilexpress**\n \n *   **Interno**\n \n *   **CorreosChile**\n \n *   **Bluexpress**\n \n *   **DHL**\n \n *   **Chilexpress**\n \n *   **Interno**\n \n *   **CorreosChile**\n \n *   **Bluexpress**\n \n *   **DHL**\n \n *   **Chilexpress**\n \n *   **Interno**\n \n *   **CorreosChile**\n \n *   **Bluexpress**\n \n *   **DHL**\n \n *   **Chilexpress**\n \n *   **Interno**\n \n *   **CorreosChile**\n \n *   **Bluexpress**\n \n *   **DHL**\n \n *   **Chilexpress**\n \n *   **Interno**\n \n *   **CorreosChile**\n \n *   **Bluexpress**\n \n *   **DHL**\n \n *   **Chilexpress**\n \n *   **Interno**\n \n *   **CorreosChile**\n \n *   **Bluexpress**\n \n *   **DHL**\n \n *   **Chilexpress**\n \n *   **Interno**\n \n *   **CorreosChile**\n \n *   **Bluexpress**\n \n *   **DHL**\n \n *   **Chilexpress**\n \n *   **Interno**\n \n *   **CorreosChile**\n \n *   **Bluexpress**\n \n *   **DHL**\n \n *   **Chilexpress**\n \n *   **Interno**\n \n *   **CorreosChile**\n \n *   **Bluexpress**\n \n *   **DHL**\n \n *   **Chilexpress**\n \n *   **Interno**\n \n *   **CorreosChile**\n \n *   **Bluexpress**\n \n *   **DHL**\n \n *   **Chilexpress**\n \n *   **Interno**\n \n *   **CorreosChile**\n \n *   **Bluexpress**\n \n *   **DHL**\n \n *   **Chilexpress**\n \n *   **Interno**\n \n *   **CorreosChile**\n \n *   **Bluexpress**\n \n *   **DHL**\n \n *   **Chilexpress**\n \n *   **Interno**\n \n *   **CorreosChile**\n \n *   **Bluexpress**\n \n *   **DHL**\n \n *   **Chilexpress**\n \n *   **Interno**\n \n *   **CorreosChile**\n \n *   **Bluexpress**')
    //   this.loading = false
    //   this.scrollToBottom()
    //   this.scrollToTopHistory()
    // }, 500) // Espera 0.5 segundos para simular realismo
  },

  beforeDestroy() {
    // Remover el listener para evitar fugas de memoria
    const chatBox = this.$refs.chatBox
    if (chatBox) {
      chatBox.removeEventListener('scroll', this.onChatBoxScroll)
    }
  },

  methods: {
    onCountryChange(val) {
      this.form.country = val
    },
    setInitialdata() {
      this.fields = []

      // Solo los administradores ven el selector de país
      if (this.mySession?.role === 'admin') {
        this.fields.push({
          fieldType: 'FieldSelect',
          useSkeleton: true,
          useLabel: true,
          name: 'country',
          disabled: false,
          label: 'País',
          validation: 'required',
          containerClass: 'col-12 col-md-4 col-lg-3 container-info'
        })
      } else {
        this.form.country = this.mySession?.country
      }
      // Si las opciones ya llegaron antes que el usuario, las seteamos ahora y quitamos skeleton
      if (this.allCountries.rows?.length && this.fields?.length) {
        this.setOptionsCountry()
      }
    },
    setOptionsCountry() {
      this.fields[0].options = this.allCountries?.rows
      this.m_setSkeletonField(this.fields, 'name', 'country', false)
    },
    askPredefined(q) {
      if (this.loading) return
      this.question = q
      this.activeQuestion = false
      this.predefinedQuestions = this.predefinedQuestions.filter(p => p !== q)
      this.sendQuestion()
    },
    scrollToBottom () {
      this.$nextTick(() => {
        const el = this.$refs.chatBox
        if (!el) return
        window.scrollBy({ top: (el.scrollHeight - (window.innerHeight * 0.5)), behavior: 'smooth' })
      })
    },

    scrollToTopHistory () {
      this.scrollToPosition(this.$refs.chatBox.scrollHeight)
      this.$nextTick(() => {
        const el = this.$refs.chatBox
        if (!el) return
        el.scrollTop = el.scrollHeight
      })
    },

    formatMessage(text) {
      if (!text) return ''
      try {
        return marked.parse(text)
      } catch (e) {
        // Fallback simple si marked no estuviera disponible
        return text
          .replace(/\n/g, '<br>')
          .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
          .replace(/\*(.*?)\*/g, '<em>$1</em>')
      }
    },
    async sendQuestion () {
      if (!this.canSendQuestion()) return

      const text = this.question.trim()
      if (!text) return

      // Limpiar el input inmediatamente y bloquearlo
      this.question = ''
      this.loading = true

      this.appendUserMessage(text)

      const botPlaceholder = this.createBotPlaceholder()

      try {
        const replyText = await this.fetchEvaReply(text)
        this.updateBotPlaceholder(botPlaceholder, replyText)
      } catch (error) {
        this.$newError('Error', error, 'large')
      } finally {
        this.loading = false
      }
    },

    canSendQuestion () {
      if (this.loading) return false
      if (this.$refs.formCountry) {
        if (!this.$refs.formCountry.onlyCheckForm?.()) return false
      }
      return !!this.question.trim()
    },

    appendUserMessage (text) {
      this.messages.push({ text, role: 'user', loading: false })
      this.$nextTick(() => {
        this.scrollToBottom()
        this.scrollToTopHistory()
      })
    },

    createBotPlaceholder () {
      this.loading = true
      this.showSpace = true
      const botPlaceholder = {
        text: '',
        role: 'bot',
        loading: true,
        typing: false,
        displayedText: ''
      }
      
      this.messages.push(botPlaceholder)
      return botPlaceholder
    },

    async fetchEvaReply (text) {
      return new Promise((resolve, reject) => {
        const data = {
          name: 'evaChatMessage',
          queryParams: { chatInput: text, country: this.form.country.name },
          headers: {
            'x-api-key': 'akatsuki-test',
            'Content-Type': 'application/json',
            'session': this.mySession.session_id,
            'Authorization': `Bearer ${this.mySession.token}`
          },
          onSuccess: (resp) => {
            // Convertimos la respuesta y resolvemos
            resolve(this.parseReply(resp))
          },
          onError: (err) => {
            reject(err)
          }
        }
        this.$store.dispatch('fetchService', data)
      })
    },

    parseReply (data) {
      if (Array.isArray(data) && data.length && data[0].output) {
        return data[0].output
      }
      if (data && (data.output || data.reply || data.message)) {
        return data.output || data.reply || data.message
      }
      return typeof data === 'string' ? data : JSON.stringify(data)
    },

    updateBotPlaceholder (placeholder, replyText) {
      placeholder.loading = false
      placeholder.typing = true
      placeholder.text = replyText
      placeholder.displayedText = ''
      this.typewriterEffect(placeholder, replyText)
    },

    typewriterEffect(placeholder, text, initialSpeed = 15, minSpeed = 1) {
      let i = 0

      const typeChar = () => {
        if (i < text.length) {
          // Aumenta caracteres progresivamente: de 1 hasta 10 (aumenta más rápido)
          const step = Math.min(1 + Math.floor(i / 30), 10)
          placeholder.displayedText += text.slice(i, i + step)
          i += step

          // Progresión acelerada (ease-in exponencial más rápida)
          const progress = i / text.length
          const eased = Math.pow(progress, 2.5)
          // Separar las operaciones para evitar mezcla inesperada de '-' y '*'
          const speedDiff = initialSpeed - minSpeed
          const easedSpeed = speedDiff * eased
          const dynamicSpeed = Math.max(initialSpeed - easedSpeed, minSpeed)

          setTimeout(typeChar, dynamicSpeed)
        }
      }

      typeChar()
    },
    
    activateQuestions (val) {
      this.activeQuestion = val
      if (val) {
        this.$nextTick(() => {
          this.scrollToBottom()
          this.scrollToTopHistory()
        })
      }
    },

    onChatBoxScroll(event) {
      const el = event.target
      if (this.isProgrammaticScroll) {
        this.isProgrammaticScroll = false
        this.previousScrollTop = el.scrollTop
        return
      }
      this.previousScrollTop = el.scrollTop
      // this.showSpace = false
    },
    scrollToPosition(position) {
      const chatBox = this.$refs.chatBox
      if (chatBox) {
        this.isProgrammaticScroll = true
        chatBox.scrollTop = position
      }
    },
    copyMessage(texto) {
      this.question = texto
    }
  }
}
</script>

<style lang="scss">
  .question-eva-agent {
    display: flex;
    position: relative;
    background: rgba(234, 247, 255, 1);
    color: rgba(110, 107, 123, 1);
    padding: 1rem;
    border-radius: 30px;
    font-size: 14px;
    font-weight: 400;
    max-width: 80%;
    text-align: left;
    float: right;
    justify-self: right;
    margin-bottom: 28px;
  }
  .history-messages {
    min-height: 58vh;
    height: 20rem;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .eva-agent-card {
    position: relative;
    // padding: 20px;
    background: white;
    border-radius: 12px;
  }
  .eva-agent-card::before {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: -1;
    border-radius: 8px;
    background: linear-gradient(90deg, rgba(50, 173, 236, 1), rgba(104, 95, 227, 1));
    filter: blur(8px)
  }
  .eva-agent-card > * {
    position: relative;
    z-index: 1;
  }
  .answer-eva-agent {
    display: flex;
    position: relative;
    overflow: hidden;
    border-radius: 30px;
    width: 100%;
    p {
      margin: 0 !important;
      line-height: 1.6;
      font-weight: 400;
      font-size: 14px;
    }
  }
  .answer-eva-agent::before {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 0;
  }
  .answer-eva-agent > * {
    position: relative;
    z-index: 1;
  }
  .user-initial {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    min-width: 28px;
    height: 28px;
    min-height: 28px;
    margin-right: 8px;
    border-radius: 50%;
    background: linear-gradient(90deg, #32ADEC 0%, #685FE3 100%);
    color: #fff;
    font-weight: bold;
    font-size: 1rem;
    box-shadow: 0 1px 4px rgba(50, 173, 236, 0.15);
  }
  .bot-initial {
    background: linear-gradient(90deg, #32ADEC 0%, #685FE3 100%);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 28px;
    width: 28px;
    min-height: 28px;
    height: 28px;
    margin-right: 8px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 1px 4px rgba(50, 173, 236, 0.15);

    img {
      width: 20px;
      height: 20px;
      object-fit: contain;
      display: block;
    }
  }
  .enviame-fixed-logo {
    // position: absolute !important;
    top: 24px;
    left: 32px;
    width: 56px;
    height: 56px;
    z-index: 10;
    background: #fff;
    border-radius: 50%;
    box-shadow: 0 2px 8px rgba(50, 173, 236, 0.15);
    padding: 8px;
    object-fit: contain;
  }
  .eva-agent-card-content {
    width: min-content;
    font-size: 1.5rem;
    font-weight: 600;
    align-content: center;
  }
  .eva-agent-container-principal {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .enviame-logo-container {
    display: flex;
    justify-content: center;
    align-items: center;
    justify-self: center;
    margin-bottom: -1rem;
  }
  .space-message {
    height: 10%;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
</style>
